/**
 * Seo component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import { useStaticQuery, graphql } from "gatsby";
import favicon16x16 from "../../images/favicon/favicon-16x16.ico";
import favicon32x32 from "../../images/favicon/favicon-32x32.ico";
import favicon64x64 from "../../images/favicon/favicon-64x64.ico";

function Seo({ description, lang, meta, title, image }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            author
            description
            title
          }
        }
      }
    `
  );

  const faviconLinks = [
    { rel: "icon", type: "image/x-icon", sizes: "16x16", href: favicon16x16 },
    { rel: "icon", type: "image/x-icon", sizes: "32x32", href: favicon32x32 },
    { rel: "shortcut icon", type: "image/x-icon", href: favicon64x64 },
  ];

  const metaDescription = description || site.siteMetadata.description;

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={Array.isArray(title) ? title[0] : title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
      link={faviconLinks}
      meta={[
        {
          name: "description",
          content: metaDescription,
        },
        {
          property: "og:title",
          content: title,
        },
        {
          property: "og:image",
          content: image,
        },
        {
          property: "og:description",
          content: metaDescription,
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary",
        },
        {
          name: "twitter:creator",
          content: site.siteMetadata.author,
        },
        {
          name: "twitter:title",
          content: title,
        },
        {
          name: "twitter:description",
          content: metaDescription,
        },
      ].concat(meta)}
    />
  );
}

Seo.defaultProps = {
  lang: "en",
  meta: [],
  description: "",
  image: "",
};

Seo.propTypes = {
  description: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]).isRequired,
  image: PropTypes.string,
};

export default Seo;
